module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.wrap ? 'WrapperInput' : 'SingleInput', {
    tag: "component",
    attrs: {
      "placeholder": _vm.placeholder,
      "inputClass": _vm.inputClass,
      "clearTooltip": _vm.clearTooltip
    },
    on: {
      "input": _vm.dateChanged
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56d11ac3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/banet-datetime-picker/plugins/VueBulmaDatepicker/index.vue
// module id = 681
// module chunks = 0